import { render, staticRenderFns } from "./ButtonColor.vue?vue&type=template&id=05d76a3e&scoped=true"
import script from "./ButtonColor.vue?vue&type=script&lang=js"
export * from "./ButtonColor.vue?vue&type=script&lang=js"
import style0 from "./ButtonColor.vue?vue&type=style&index=0&id=05d76a3e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d76a3e",
  null
  
)

export default component.exports